enum LlojiDokumentKandidati {
  KERKESE_APLIKIMI = 'KERKESE_APLIKIMI',
  DIPLOME_NIVELI_II = 'DIPLOME_NIVELI_II',
  LISTE_NOTASH_E_NOTERIZUAR = 'LISTE_NOTASH_E_NOTERIZUAR',
  DIPLOME_BACHELOR_E_NOTERIZUAR = 'DIPLOME_BACHELOR_E_NOTERIZUAR',
  LISTE_NOTASH_E_NOTERIZUAR_BACHELOR = 'LISTE_NOTASH_E_NOTERIZUAR_BACHELOR',
  DIPLOME_MASTERI_NOTERIZUAR = 'DIPLOME_MASTERI_NOTERIZUAR',
  LISTE_NOTASH_E_NOTERIZUAR_MASTERI = 'LISTE_NOTASH_E_NOTERIZUAR_MASTERI',
  CERTIFIKATE_GJUHE_HUAJ_E_NOTERIZUAR = 'CERTIFIKATE_GJUHE_HUAJ_E_NOTERIZUAR',
  KARTE_IDENTITETI = 'KARTE_IDENTITETI',
  RAPORT_MJEKO_LIGJOR = 'RAPORT_MJEKO_LIGJOR',
  CV = 'CV',
  FOTO = 'FOTO',
  DESHMI_PENALITETI = 'DESHMI_PENALITETI',
  DESHMI_PUNE_TRE_VJECARE = 'DESHMI_PUNE_TRE_VJECARE',
  REKOMANDIM_LARGIMI_NGA_PUNEDHENESI = 'REKOMANDIM_LARGIMI_NGA_PUNEDHENESI',
  DEKLARATE_ANETARESIMI_NE_PARTI_POLITIKE = 'DEKLARATE_ANETARESIMI_NE_PARTI_POLITIKE',
  DEKLARATE_ANETARESIMI_SIGURIMI_SHTETIT = 'DEKLARATE_ANETARESIMI_SIGURIMI_SHTETIT',
  LIBREZE_PUNE = 'LIBREZE_PUNE',
  DOKUMENT_AUTORESIE_BOTIMI_SHKENCOR = 'DOKUMENT_AUTORESIE_BOTIMI_SHKENCOR',
  PAGESA = 'PAGESA',
  DEKLARIM_RAST_PER_RAST = 'DEKLARIM_RAST_PER_RAST',
}

interface DocumentItem {
  key: string;
  value: string;
  desc?: string;
}

interface DocumentCategory {
  categoryKey: string;
  categoryTitle: string;
  categoryDescription?: string;
  documents: DocumentItem[];
}

export interface StaticTemplateFile extends DocumentItem {
  staticPath?: string;
  fullName: string;
  isApiFile?: boolean;
}

export const documentCategories: DocumentCategory[] = [
  {
    categoryKey: 'personal_documents',
    categoryTitle: 'Dokumentet Personale',
    documents: [
      {
        key: LlojiDokumentKandidati.KERKESE_APLIKIMI,
        value: 'Formulari i Kërkesës për Aplikim',
      },
      {
        key: LlojiDokumentKandidati.KARTE_IDENTITETI,
        value: 'Karta e identitetit (ID)',
      },
      {
        key: LlojiDokumentKandidati.FOTO,
        value: 'Fotografi',
      },
      {
        key: LlojiDokumentKandidati.CV,
        value: 'Curriculum Vitae (CV)',
      },
      {
        key: LlojiDokumentKandidati.PAGESA,
        value: 'Mandat pagesa e tarifës së regjistrimit',
      },
    ],
  },
  {
    categoryKey: 'education_qualifications',
    categoryTitle: 'Arsimimi dhe Kualifikimet',
    documents: [
      {
        key: LlojiDokumentKandidati.DIPLOME_BACHELOR_E_NOTERIZUAR,
        value: 'Diplomë e Nivelit të Parë (Bachelor)',
        desc: 'Origjinale ose kopje e noterizuar',
      },
      {
        key: LlojiDokumentKandidati.LISTE_NOTASH_E_NOTERIZUAR_BACHELOR,
        value: 'Lista e Notave (Bachelor)',
        desc: 'Origjinale ose kopje e noterizuar',
      },
      {
        key: LlojiDokumentKandidati.DIPLOME_MASTERI_NOTERIZUAR,
        value: 'Diplomë e Nivelit të Dytë (Master Shkencor)',
        desc: 'Origjinale ose kopje e noterizuar',
      },
      {
        key: LlojiDokumentKandidati.LISTE_NOTASH_E_NOTERIZUAR_MASTERI,
        value: 'Lista e Notave (Master Shkencor)',
        desc: 'Origjinale ose kopje e noterizuar',
      },
      {
        key: LlojiDokumentKandidati.DIPLOME_NIVELI_II,
        value: 'Diplomë e Integruar e Nivelit të Dytë',
        desc: 'Origjinale ose kopje e noterizuar (NËSE KA). Diplomat e huaja duhet te jene te njesuar nga Min. Arsimit',
      },
      {
        key: LlojiDokumentKandidati.LISTE_NOTASH_E_NOTERIZUAR,
        value: 'Lista e Notave (për Diplomën e Integruar)',
        desc: 'Origjinale ose kopje e noterizuar (NËSE KA)',
      },
      {
        key: LlojiDokumentKandidati.CERTIFIKATE_GJUHE_HUAJ_E_NOTERIZUAR,
        value: 'Certifikata e Njohjes së Gjuhës së Huaj',
        desc: 'Origjinale ose kopje e noterizuar',
      },
    ],
  },
  {
    categoryKey: 'integrity_health_experience',
    categoryTitle: 'Integriteti, Shëndeti dhe Përvoja Profesionale',
    documents: [
      {
        key: LlojiDokumentKandidati.LIBREZE_PUNE,
        value: 'Vërtetim i vjetërsisë në punë',
        desc: 'Librezë pune, vërtetime nga organet e sigurimeve shoqërore për kontributet e derdhura ose vërtetim nga organet tatimore për profesionet e lira juridike',
      },
      {
        key: LlojiDokumentKandidati.DESHMI_PUNE_TRE_VJECARE,
        value: 'Dëshmi, Vërtetime dhe Rekomandime',
        desc: 'Nga persona ose institucione ku keni punuar në 3 vitet e fundit shoqëruar me një përshkrim të punës suaj si jurist',
      },
      {
        key: LlojiDokumentKandidati.REKOMANDIM_LARGIMI_NGA_PUNEDHENESI,
        value: 'Vërtetim nga punëdhënësi i fundit dhe/ose organet disiplinore',
        desc: 'Që nuk jeni larguar nga detyra ose ju është hequr licensa, autorizimi ose leja për ushtrimin e një profesioni për shkaqe disiplinore',
      },
      {
        key: LlojiDokumentKandidati.DEKLARATE_ANETARESIMI_SIGURIMI_SHTETIT,
        value: 'Vetëdeklarim (Për pastërtinë e figures)',
        desc: 'Deklaratë që nuk keni qenë anëtar, bashkëpunëtor apo i favorizuar nga Sigurimi i Shtetit para vitit 1990 dhe që nuk keni qenë bashkëpunëtor apo agjent i shërbimeve sekrete',
      },
      {
        key: LlojiDokumentKandidati.DEKLARATE_ANETARESIMI_NE_PARTI_POLITIKE,
        value: 'Vetëdeklarim (Për angazhimin politik)',
        desc: 'Deklaratë që vërteton se nuk jeni anëtar i asnjë partie politike në kohën e kandidimit',
      },
      {
        key: LlojiDokumentKandidati.DESHMI_PENALITETI,
        value: 'Dëshmi Penaliteti (vërtetim i gjendjes gjyqësore)',
      },
      {
        key: LlojiDokumentKandidati.RAPORT_MJEKO_LIGJOR,
        value: 'Raporti Mjeko-Ligjor',
      },
      {
        key: LlojiDokumentKandidati.DEKLARIM_RAST_PER_RAST,
        value:
          'Deklarim rast për rast i interesave private (Konflikti i Interesit - nëse ka)',
        desc: 'Deklaratë e veçantë për raste specifike',
      },
    ],
  },
];

export const documentList = documentCategories.flatMap(
  category => category.documents,
);

export const staticTemplateFiles: StaticTemplateFile[] = [
  {
    key: 'VETEFIGURA_TEMPLATE',
    value: 'Vetëdeklaratë për pastërtinë e figurës',
    fullName: 'Vetëdeklaratë (Për pastërtinë e figures).pdf',
    desc: 'Deklarim për mosqenë anëtar/bashkëpunëtor i Sigurimit të Shtetit përpara vitit 1990',
    staticPath: '/documents/Vetëdeklaratë (Për pastërtinë e figures).pdf',
  },
  {
    key: 'VETEPOLITIKE_TEMPLATE',
    value: 'Vetëdeklaratë për angazhimin politik',
    fullName: 'Vetëdeklaratë (Për angazhimin politik).docx',
    desc: 'Deklarim për mospjesëmarrje në struktura dhe aktivitete politike',
    staticPath: '/documents/Vetëdeklaratë (Për angazhimin politik).docx',
  },
  {
    key: 'FATURE_TEMPLATE',
    value: 'Faturë Arkëtimi',
    fullName: 'Fature_arketimi.doc',
    desc: 'Formular për faturën e arkëtimit',
    staticPath: '/documents/Fature_arketimi.doc',
  },
  {
    key: 'DEKLARIM_RAST_PER_RAST_TEMPLATE',
    value: 'Deklarim Rast për Rast',
    fullName: 'DEKLARIM_rast_per_rast.doc',
    desc: 'Formular për deklarim rast për rast',
    staticPath: '/documents/DEKLARIM_rast_per_rast.doc',
  },
  {
    key: 'KERKESE_APLIKIM',
    value: 'Kërkesë për Aplikim',
    fullName: 'Kerkese_per_Aplikim.pdf',
    desc: 'Dokument i gjeneruar nga sistemi për kërkesën tuaj',
    isApiFile: true,
  },
];
